module.exports = new __parcel__URL__("card-mastercard.487f97ac.svg").toString();